import { Outlet } from "react-router-dom";

function PublicLayout() {
  return (
    <div data-testid="public-layout">
      <Outlet />
    </div>
  );
}

export default PublicLayout;
